<template>
  <b-skeleton-wrapper :loading="loading">
    <template #loading>
      <ul class="checkbox-filter__items padding-top-16">
        <li
          class="checkbox-filter__item flex-start"
          v-for="(item, index) in [
            1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
          ]"
          :key="`b-${index}`"
        >
          <b-skeleton
            :type="multiple ? 'button' : 'avatar'"
            width="20px"
            height="20px"
          ></b-skeleton>
          <b-skeleton
            width="90%"
            class="margin-right-16 margin-bottom-0"
          ></b-skeleton>
        </li>
      </ul>
    </template>
    <slot name="default"></slot>
  </b-skeleton-wrapper>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
